/*! Progress Bar On Scroll v1.0 by Didier */
var progressBarOnScroll = (function () {

    var defaultOptions = {
        cssClass: 'progress-bar'
    };

    // private methods
    var pbar = {
        initialized: false,
        options: defaultOptions,
        init: function(options) {
            this.options = $.extend(defaultOptions, options);
            this.createBar();
            this.updateProgressBar();
            this.initialized = true;

            var thisbar = this;
            $(window).scroll($.throttle(300, function() { thisbar.updateProgressBar(); }));
        },
        createBar: function() {
            $('<div aria-hidden="true" class="' + this.options.cssClass + '"><div class="' + this.options.cssClass + '__slider" /></div>').appendTo('body');
        },
        updateProgressBar: function () {
            var doc = $(document),
                percentageScrolled = doc.scrollTop() / (doc.height() - $(window).height()),
                barWidth = Math.ceil(doc.outerWidth() * percentageScrolled);
            
            $('.' + this.options.cssClass + '__slider').width(barWidth);
        }
    }

    // public methods
    return  {
        init: function(progressBarCssClass) {
            if (!pbar.initialized) {
                pbar.init(progressBarCssClass);
            } else {
                throw "progress bar (" + progressBarCssClass.cssClass + ") already initialized"
            }
        }
    }

})();